import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  loadMethods: ["fetchProducts", "loadPicks"],
});
